import getActionUrl from '../utilities/getActionUrl';

export default function NotificationPopoverListItemActions({
  notification,
  navigate,
  scope,
}) {
  return (
    <div className="flex space-x-2 items-center">
      {notification.actions?.map((action) => (
        <a
          key={`notification-${notification.id}-action-${action.url}`}
          className="text-xs text-gray-500 font-medium hover:underline transition border-0"
          href={getActionUrl(action, navigate, scope)}
        >
          {action.label}
        </a>
      ))}
    </div>
  );
}
